import { loadNavigation } from "~/features/navigation/redux/navigationThunks";
import { type NavigationNode } from "~/domains/navigation/types/NavigationTypes";
import { getStore } from "~/app/store/getStore";

export function create(rawData: { navigation: string; flyoutNavigation: string }) {
  getStore().dispatch(loadNavigation(rawData));

  return null;
}

export type NavigationData = {
  root: NavigationNode;
  nodes: Dictionary<NavigationNode>;
};
